module.exports = __webpack_public_path__ + "img/3-l@2x.72f3c075.jpg";